<div>
    <rask-menu-button alignment="left" [template]="tpl" #menu>
    </rask-menu-button>

    <ng-template #tpl>
        <div class="menu-btn-container">
            <rask-arbetsorder-masshantering
                [data]="data">
            </rask-arbetsorder-masshantering>
        </div>
    </ng-template>
</div>
